import React from 'react';
import './GlitchText.css';

export default function GlitchText({
  children,
  speed = 1,
  enableOnHover = false
}) {
  return (
    <div
      className={`glitch ${enableOnHover ? 'hover' : ''}`}
      style={{ animationDuration: `${1 / speed}s` }}
      data-text={children}
    >
      {children}
    </div>
  );
}
